<template>
  <div id="grid-reportePA">
    <v-flex>
      <v-toolbar color="white" dark flat dense cad>
        <v-toolbar-title class="indigo--text"
          >Reporte preguntas abiertas</v-toolbar-title
        >
      </v-toolbar>
    </v-flex>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex xs12 md6>
          <v-select
            v-model="nivelValue"
            :items="nivelSelect"
            item-text="name"
            item-value="code"
            label="Nivel"
          ></v-select>
        </v-flex>
        <v-flex xs12 md8>
          <v-select
            v-model="tipoPruebaValue"
            :items="tipoPruebaSelect"
            label="Tipo Prueba"
          >
          </v-select>
        </v-flex>
        <v-flex xs12 md8>
          <v-select
            v-model="asignaturaValue"
            :items="asignaturaSelect"
            label="Asignatura"
          >
          </v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fechaInicioFormatted"
                label="Día de carga"
                prepend-icon="event"
                v-on="on"
                @blur="fechaValue = parseDate(fechaInicioFormatted)"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaValue"
              @input="menu1 = false"
              no-title
              locale="es"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="loadData()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              :headers="headers"
              :items="datosPaginados"
              :page.sync="page"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              @page-count="pageCount = $event"
              class="elevation-1"
              hide-actions
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left">{{ props.item.nivel }}</td>
                  <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
                  <td class="text-xs-left">{{ props.item.asignatura }}</td>
                  <td class="text-xs-left">{{ props.item.forma }}</td>
                  <td class="text-xs-left">{{ props.item.numeroPregunta }}</td>
                  <td class="text-xs-left">{{ props.item.esperado }}</td>
                  <td class="text-xs-left">{{ props.item.actual }}</td>
                  <td class="text-xs-left">{{ props.item.faltantes }}</td>
                  <td class="text-xs-left">
                    {{ props.item.porcentaje.toFixed(1) }}%
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-flex xs12 sm6>
              <v-text-field
                value=""
                label="Total de Registros"
                v-model="cantRegistros"
                disabled
              ></v-text-field>
            </v-flex>
            <div class="text-center pt-2">
              <v-pagination
                @input="changePage(page)"
                v-model="page"
                :length="pageCount"
                :total-visible="9"
                circle
              >
              </v-pagination>
            </div>
          </template>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import { misMixins } from "@/mixins/myMixing.js";

export default {
  name: "grid-reportePA",

  components: {
    AlertEmpty,
    Loading,
  },
  mixins: [misMixins],
  props: {},

  data() {
    return {
      botonDescarga: true,
      loading: false,
      alerta: false,
      dialogLoading: false,
      id: "",
      totalRegistro: "",
      idContrato: "",
      headers: [
        { text: "Nivel", align: "left", sortable: false, value: "" },
        { text: "Tipo Prueba", sortable: false, value: "" },
        { text: "Asignatura", sortable: false, value: "" },
        { text: "Forma", sortable: false, value: "" },
        { text: "N. pregunta", sortable: false, value: "" },
        { text: "Esperado", sortable: false, value: "" },
        { text: "Actual", sortable: false, value: "" },
        { text: "Faltantes", sortable: false, value: "" },
        { text: "Porcentaje", sortable: false, value: "" },
      ],
      itemsReporte: [],
      idUserLogged: "",
      //filtros
      nivelSelect: [],
      nivelValue: null,
      tipoPruebaSelect: [],
      tipoPruebaValue: null,
      asignaturaSelect: [],
      asignaturaValue: null,
      menu1: false,
      fechaValue: null,
      fechaInicioFormatted: null,

      page: 1,
      pageCount: 0,
      datosPaginados: [],
      paginaActual: 1,
      cantRegistros: 0,
      rowsPerPageItems: [20],
      pagination: {
        page: 1,
        rowsPerPage: 50,
        pages: 0,
      },
      totalPages: 0,
      totalRegistros: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;
      setTimeout(() => (this.dialogLoading = false), 5000);
    },
    fechaValue(val) {
      this.fechaInicioFormatted = this.formatDate(this.fechaValue);
    },
  },

  created() {
    // console.log("reportePreguntas");

    this.idContrato = this.$store.getters.contratoStored;
    this.tab = this.$store.getters.subTabSelectedStored;

    this.loadData();
  },
  mounted() {},
  computed: {},
  methods: {
    async loadReportePA() {
      this.body = {
        nivel: this.nivelValue,
        tipoPrueba: this.tipoPruebaValue,
        asignaturaPrueba: this.asignaturaValue,
        idContrato: this.idContrato,
        fechaEjecucion:
          this.fechaValue && this.fechaValue != null
            ? this.formatDate(this.fechaValue)
            : null,
        pageSize: 20,
        pageNumber: this.page,
      };
      return await axios
        .post("/preguntasAbiertas/getReporte/", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response);
          }
          return [];
        });
    },

    async loadData() {
      this.loading = true;
      this.itemsReporte = await this.loadReportePA();

      if (this.itemsReporte.length > 0) {
        this.cantRegistros = this.itemsReporte.length;
        this.pageCount = Math.ceil(
          this.itemsReporte.length / this.rowsPerPageItems
        );
        this.getDataPagina(this.page);
        this.alerta = false;
        this.botonDescarga = false;
      } else {
        this.alerta = true;
        this.botonDescarga = true;
        this.datosPaginados = [];
        this.cantRegistros = 0;
        this.pageCount = 0;
      }

      this.loadNivelSelect();
      this.loadTipoPruebaSelect();
      this.loadAsignaturaSelect();
      this.loading = false;
    },
    loadNivelSelect() {
      let niv = [];
      this.itemsReporte.forEach(function (c) {
        let index = niv.findIndex((x) => x.nivel == c.nivel);
        if (index === -1) {
          if (c.nivel != null && c.nivel != "") {
            niv.push(c.nivel);
          }
        }
      });
      this.nivelSelect = niv;
    },
    loadTipoPruebaSelect() {
      let tip = [];
      this.itemsReporte.forEach(function (d) {
        let index = tip.findIndex((x) => x.tipoPrueba == d.tipoPrueba);
        if (index === -1) {
          tip.push(d.tipoPrueba);
        }
      });
      this.tipoPruebaSelect = tip;
    },
    loadAsignaturaSelect() {
      let asig = [];
      this.itemsReporte.forEach(function (d) {
        let index = asig.findIndex((x) => x.asignatura == d.asignatura);
        if (index === -1) {
          asig.push(d.asignatura);
        }
      });
      this.asignaturaSelect = asig;
    },
    clear() {
      this.fechaValue = null;
      this.nivelValue = null;
      this.tipoPruebaValue = null;
      this.asignaturaValue = null;
      this.loadData();
    },

    // paginacion
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.getDataPagina(this.page);
    },
    getDataPagina(noPagina) {
      this.paginaActual = noPagina;
      this.datosPaginados = [];

      let ini = noPagina * this.rowsPerPageItems - this.rowsPerPageItems;
      let fin = noPagina * this.rowsPerPageItems;
      this.datosPaginados = this.itemsReporte.slice(ini, fin);
    },
    getDataFull() {
      this.datosPaginados = [];
      this.page = 1;
      this.datosPaginados = this.itemsReporte.slice(
        0,
        this.itemsReporte.length
      );
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>
